import * as React from "react";
import ReactQuill from 'react-quill';
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Input, Icon, Form, Button } from 'antd';
import { TextView } from "src/core/ui/text.view";
import Frame from './frame';
const FormItem = Form.Item;

interface RichTextViewProps {
	value: any;
	mode: ControlMode;
	toolbarClass?: string;
	required?: boolean;
	label?: string;
	description?: string;
	containerClassName?: string;
	onChanged: (html: any) => void
}

interface RichTextViewState{
	text: any;
	codeView: boolean;
	disablePreview: boolean;
}

@observer
export class RichTextView extends React.Component<RichTextViewProps, RichTextViewState>{

	constructor(props) {
		super(props);
		this.state = {
			text: this.props.value || '',
			codeView: false,
			disablePreview: false
		};
	}
	
	public componentWillReceiveProps(nextProps: RichTextViewProps) {
		
		if (nextProps.mode != this.props.mode) {
			if (nextProps.mode == 'edit') {

				if (!!nextProps.value && nextProps.value.startsWith("<html>")) {
					this.setState({ disablePreview: true, codeView: true }, () => this.updateFrame(this.state.text));
				}
				
			}
		}

		if (nextProps.value && nextProps.value !== this.props.value) {
			this.setState({
				text: (nextProps.value as string).substr(0)
			});

			if (nextProps.value.startsWith("<html>")) {
				this.setState({ disablePreview: true, codeView: true }, () => this.updateFrame(this.state.text));
			}
			
		}
	}

	componentDidMount() {
		if (!!this.props.value && this.props.value.startsWith("<html>") && this.props.mode == 'edit') {
			this.setState({ disablePreview: true, codeView: true }, () => this.updateFrame(this.state.text));
		}
		if (!!this.frame) {
			this.frame.setContent(this.props.value);
		}
	}

	frame: Frame;

	public render() {
		
		const { text } = this.state;
		const { mode, onChanged } = this.props;

		const modules = {
			toolbar: [
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }, { 'font': [] }],
				['bold', 'italic', 'underline', 'strike', 'blockquote'],
				[{ 'size': ['small', false, 'large', 'huge'] }, { 'color': [] }, { 'background': [] }, { 'direction': 'rcl' }, { 'align': [] }],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
				['link', 'image'],
				['clean']
			]
		};

		const format = [
			'header', 'font',
			'bold', 'italic', 'underline', 'strike', 'blockquote',
			'list', 'bullet', 'indent',
			'link', 'image', 'background', 'size', 'align', 'direction', 'color'
		];

		return (
			<FormItem label={this.props.label} required={this.props.required} help={this.props.description}>
				{this.props.mode == 'edit' && <Button disabled={this.state.disablePreview} onClick={() => this.setState({ codeView: !this.state.codeView }, () => this.updateFrame(this.state.text))}>{!this.state.codeView ? 'Show code' : (this.state.disablePreview ? 'Disabled due to complex html template' : 'Show rich editor')}</Button>}
				{this.props.mode == 'edit' && !this.state.codeView &&
					<div className={this.props.containerClassName ? this.props.containerClassName: "wysiwyg-editor"}>
						<ReactQuill theme='snow' value={text} onChange={this.handleChange} modules={modules} formats={format} />
					</div>
				}
				{this.props.mode == 'edit' && this.state.codeView &&
					<div className={this.props.containerClassName ? this.props.containerClassName : "wysiwyg-editor"}>
					<TextView mode='edit' value={text} onChanged={this.handleCodeChange} rows={10} />
					</div>
				}
				{(this.props.mode == 'display' || this.state.disablePreview || this.state.codeView) &&
					<Frame ref={e => this.frame = e} className="editor-preview" content={this.state.text} />
				}
			</FormItem>
		);
	}

	private constructInnerHtmlInjection = () => {
		return {
			__html: this.state.text
		}
	}

	updateFrame = (content) => {

		if (this.frame) {
			this.frame.setContent(content);
		}
	}

	private handleCodeChange = (e) => {
		this.props.onChanged(e);
		this.setState({ text: e }, () => this.updateFrame(this.state.text));

		if (e.startsWith("<html>") != this.state.disablePreview)
			this.setState({ codeView: true, disablePreview: e.startsWith("<html>")});

	}

	private handleChange = (content: string, delta: any, source: any, editor: any) => {
		this.props.onChanged(editor.getHTML());
		this.setState({ text: content });
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/richtextview/text.view.rich.tsx